import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { useEffect } from "react";
import { isMobile } from "react-device-detect";
import { Link } from "react-router-dom";
import { FONTS } from "../constants";
import { LogoNameMainPageScroll } from "../dashboard/Common/LogoNameMainPageScroll";
import { stateType } from "../state";
import { setMetaTags } from "../helpers/pageMeta";

const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		policy: {
			fontFamily: FONTS,
			alignItems: "center",
			display: "flex",
			flexDirection: "column",
			width: "100vw",
		},
		policyTitle: {
			fontFamily: FONTS,
			fontSize: "40px",
			color: "black",
			marginTop: "80px",
			paddingLeft: "-500px",
		},
		logoWrapper: {
			marginLeft: "-450px",
			marginTop: "-20px",
			marginRight: "150px",
		},
		policySubTitle: {
			width: isMobile ? "90%" : "800px",
			fontSize: "30px",
			marginTop: "40px",
			color: "grey",
		},
		policyText: { width: isMobile ? "100%" : "800px", color: "grey" },
		policyText2: {
			width: isMobile ? "100%" : "800px",
			color: "grey",
			marginTop: "50px",
		},
		contact: {
			marginLeft: "0px",
			marginTop: "50px",
			cursor: "pointer",
			marginBottom: "20px",
		},
	});
});

export const PrivacyPage = (state: stateType) => {
	const classes = useStyles();
	useEffect(() => {
		setMetaTags();
		window.scrollTo(0, 0);
		document.title = "Dash AI | Privacy Policy";
	}, []);

	return (
		<div className="App" style={{ overflow: "hidden" }}>
			<div
				className="mainSection"
				style={{
					justifyContent: "center",
					display: "flex",
					flexDirection: "row",
					height: "150px",
				}}
			>
				<div className={classes.logoWrapper}>
					<Link to="/" style={{ textDecoration: "none" }}>
						<LogoNameMainPageScroll></LogoNameMainPageScroll>
					</Link>
				</div>
				<div className={classes.policyTitle}>Privacy Policy</div>
			</div>
			<div className={classes.policy}>
				<div className={classes.policyText2}>
					At Dash AI, we are committed to protecting your privacy and
					want to ensure we take all the necessary steps to inform you
					of how your data may be used on dash-ai.app. Please take a
					moment to read the outlined policy and feel free to contact
					us if you have any questions/concerns. This policy may be
					updated periodically, Dash AI encourages you to check back
					in from time to time. By using the DashA.com website, you
					consent to the data practices described in this statement.
				</div>
				<div className={classes.policySubTitle}>
					Personal Data Collection
				</div>
				<div className={classes.policyText}>
					We do not collect any personal information. This may change
					in the future if additional functionalty is added such a
					login capability. This is will be 100% opt-in.
				</div>
				<div className={classes.policySubTitle}>Uploaded Datasets</div>
				<div className={classes.policyText}>
					Data uploaded to the DashAI dashboard remains local to the
					machine and is not stored in any servers. No part of the
					dashboard data is stored anywhere on our servers.
				</div>
				<div className={classes.policySubTitle}>
					Information Collection from Minors
				</div>
				<div className={classes.policyText}>
					We do not knowingly solicit data from or market to children
					under the age of 18. By using this site, you are
					acknowledging that you are at least 18 years of age or have
					parent/guardian consent to use dash-ai.app.
				</div>
			</div>
		</div>
	);
};
